export const UI_TAB_CHATBOT = {
    // ─── Hành động (mặc định) ───
    ACTIONS: 'actions',                                     // Nhấn nút Bắt đầu (Facebook)
    MENU: 'menu',                                           // Cài đặt menu (Facebook)
    MESSAGE_PAGE: 'messagepage',                            // Nhắn tin tới page
    COMMENT: 'comment',                                     // Bình luận bài viết (Facebook/Instagram)
    FRIEND_REQUEST: 'friendrequest',                        // Chấp nhận lời mời kết bạn (Zalo Personal)
    // ─── Kịch bản ───
    SCENARIOS: 'scenarios',
    // ─── Báo cáo ───
    REPORT_MESSAGE: 'report-message',                       // Báo cáo tin nhắn kịch bản
    REPORT_FEEDBACK: 'report-feedback',                     // Báo cáo phản hồi khách hàng
    REPORT_CAMPAIGN_USER: 'report-campaignuser',            // Người đăng ký marketing
    // ─── Marketing ───
    MARKETING_CUSTOMER_GROUPS: 'marketing-customergroups',  // Nhóm khách hàng
    MARKETING_CUSTOMERS: 'marketing-customers',             // Danh sách khách hàng
    MARKETING_LOGS: 'marketing-logs',                       // Lịch sử gửi chiến dịch
    // ─── Cài đặt ───
    SETTINGS: 'settings',
} as const;

/** Giá trị 1 tab hợp lệ của màn chi tiết bot */
export type UiTabChatbot = typeof UI_TAB_CHATBOT[keyof typeof UI_TAB_CHATBOT];

export const chatbotModels = {
    UI_CREATE_NEW_BOT: 1, // tạo bot mới
    UI_ADD_MORE_PAGE: 2, // kết nối page mới cho bot đã có


    TYPE_BOT_RESPONSE_COMPOSE: 'compose', // soạn thảo tin nhắn
    TYPE_BOT_RESPONSE_LINK: 'link', // chọn link bài viết
    TYPE_BOT_RESPONSE_SCRIPT: 'script', // chọn kịch bản có sẵn

    TYPE_BUTTON_URL: 'url',
    TYPE_BUTTON_BLOCK: 'block',
    TYPE_BUTTON_MESSAGE: 'message',


    TYPE_CARD_CHATBOT_TEXT: 'text',
    TYPE_CARD_CHATBOT_IMAGE: 'image',
    TYPE_CARD_CHATBOT_GALLERY: 'gallery',
    TYPE_CARD_CHATBOT_BUTTON: 'button',
    TYPE_CARD_CHATBOT_KEYWORD: 'keyword',
    TYPE_CARD_CHATBOT_INBOX_DEFAULT: 'inbox_default', // phản hồi mặc định
    TYPE_CARD_CHATBOT_INBOX_START: 'inbox_start', // phản hồi khi bắt đầu


    TYPE_CLONE_MENU_GROUP: 1,
    TYPE_CLONE_MENU_BLOCK: 2,
} as const;

export interface ISelectChatbotOption {
    label: string,
    value: any,
    subLabel?: string,
    disabled?: boolean,
    img?: string,
}

export interface ITagItemSelect {
    id: string,
    code?: string,
    name: string,
    backgroundColor: string,
    color: string,
}


/** Cấu hình tự động comment/trả lời comment */
export interface BotCommentSettings {
    active: number;
    /** Loại comment*/
    type: string;
    /** Phạm vi áp dụng */
    range: any[];
    /** Độ trễ trả lời */
    delay: number;
}

/** Chi tiết 1 mục trong Menu (Persistent Menu) */
export interface MenuItem {
    active: number;
    title: string;
    /** Loại hành động: 'block' (chạy kịch bản), 'url' (mở link), 'message' */
    type: 'block' | 'url' | 'message' | string;
    /** ID của block sẽ chạy (nếu type = block) */
    block_id?: string;
    /** Link sẽ mở (nếu type = url) */
    url?: string;
    message_id?: string;
}

export interface ButtonStartItem {
    /** Loại hành động: 'block', 'url', 'message' */
    type: 'block' | 'url' | 'message' | string;
    value: string;
}

/** Câu hỏi mẫu*/
export interface MenuQuestion {
    text: string;
    block_id: string;
}

/** Cấu hình Menu trên Facebook */
export interface BotMenuSettings {
    /** Tắt ô nhập liệu của user (chỉ cho bấm menu)? (0: Không, 2: Có - tùy logic server) */
    disabled_user_input: number;
    /** Hiển thị nút "Bắt đầu" (Get Started)? 1: Có, 0: Không */
    get_started: number;
    /** Lời chào (Greeting text) hiển thị trước khi bấm bắt đầu */
    greeting: string;
    /** Bật/tắt lời chào. 1: Bật */
    greeting_active: number;
    /** Menu cố định (Persistent Menu) */
    persistent_menu: MenuItem[];
    /** Cấu hình nút Bắt đầu (Get Started) */
    get_started_script: ButtonStartItem[];
    /** Danh sách câu hỏi thường gặp (Ice Breakers) */
    questions: MenuQuestion[];
}

/** Cấu hình riêng cho Zalo OA */
export interface BotZaloSettings {
    active: number;
    image_url: string;
    title: string;
    sub_title: string;
    message: string;
}

export interface BotSendFriendZaloSettings {
    active: number;
    message: {
        type: string; // 'block' | 'message' | 'url'
        value: string; // ID Kịch bản hoặc ID tin nhắn ở bảng script_messages hoặc URL
    }[]
}

/** Cấu hình hội thoại chung */
export interface BotConversationSettings {
    isRead: number;
    isRunGroup: number;
    /** Thời gian reset luồng (gửi block Start) tính bằng giây. Mặc định 86400 (24h); null khi chưa set */
    timeSendBlockStart: number | null;
    timeSendBlockDefault: number | null;
    tags: any[];
}

/** Tổng hợp các setting trong Bot */
export interface BotSettings {
    comment?: BotCommentSettings;
    menu?: BotMenuSettings;
    getInfoUserZalo?: BotZaloSettings;
    share?: { active: number };
    conversation?: BotConversationSettings;
    inbox?: BotCommentSettings;
    accept_friend_action?: BotSendFriendZaloSettings;
}

/** Đối tượng Bot chính */
export interface BotItem {
    id: string;
    name: string;
    active: number;
    channel: 'facebook' | 'zalo' | string;
    businessId: string;
    fanpageId: string[];
    settings: BotSettings;
    createdTime: number;

    // chỉ có trên UI
    pageConnected?: any[], // lấy ra toàn bộ các page đã kết nối với mọi bot
    fanpageName?: string,
    duration?: number,
    expiredTime?: number,
}

/** Nhóm kịch bản (Group) */
export interface BotGroup {
    id: string;
    botId: string;
    name: string;
    /** Loại nhóm: 'script' (kịch bản thường), 'keyword' (từ khóa) */
    type: 'script' | 'keyword' | string;
    /** Thứ tự sắp xếp */
    order: number;
    createdTime: number;
}

/** Khối kịch bản (Block) - Nằm trong Group */
export interface BotBlock {
    id: string;
    botId: string;
    groupId: string;
    name: string;
    alias: string | null;
    /** Loại mặc định: 'start' (kịch bản chào), 'default' (mặc định), hoặc null */
    default: 'start' | 'default' | string | null;
    order: number;
    createdTime: number;

    // chỉ có ở UI để for thôi
    active?: boolean;
    childs?: BotCard[]; // danh sách thẻ tin nhắn (card) trong block

    // BỔ SUNG (port): danh sách id block được liên kết, build trong handleBlockDiagrams.
    // V1 gán động bằng (block as any).links — V2 khai báo tường minh để bỏ any.
    links?: string[];
}

/** Thẻ tin nhắn (Card)  */
export interface BotCard {
    id: string;
    botId: string;
    groupId: string;
    blockId: string;
    /** Loại nội dung: văn bản, ảnh, thư viện ảnh, nút bấm... */
    type: string; // 'text' | 'image' | 'gallery' | 'button' | 'keyword' | 'inbox_default' (Phản hồi mặc điịnh) |
    active: number;
    order: number;
    /** Cấu hình nội dung chi tiết của card (text, url ảnh, actions...) */
    settings: any;
    createdTime: number;
    /** UI state: tab đang mở cho card API (Params / Headers / Body) */
    _activeTab?: string;
    [key: string]: any;
}


export interface KeywordCard extends BotCard {
    settings: {
        keyword: {
            from: string;
            match?: string;
            checkMark?: number;
            values: string[];
            defaultLabelEnabled: number // 1: Bật, 2: Tắt (nhãn ở default)
            actions: Array<{ type: 'text' | 'block'; content?: string; text?: string }>;
        },
        tags: string[] // danh sách nhãn gắn với card
    };
}

/**
 * Interface màn bình luận bài viết (/feature/chatbot/comment)
 */
export interface KeywordConditionGroup {
    active: number;
    values: string[];
}

export interface KeywordCondition {
    active: number; // hoạt động  (1: có, 2: không)
    is: KeywordConditionGroup; // trùng khớp chính xác
    start_with: KeywordConditionGroup; // bắt đầu với nội dung
    have: KeywordConditionGroup; // chứa nội dung
    have_not: KeywordConditionGroup; // không chứa nội dung
    start_with_text: KeywordConditionGroup; // bắt đầu với từ khóa
    have_text: KeywordConditionGroup; // chứa từ khóa
    have_not_text: KeywordConditionGroup; // không chứa từ khóa
}

export interface CommentCondition {
    id?: string;
    botId: string;
    name: string;

    active: number;

    typePost: number; // 1 là tất cả, 2 là 1 bài viết cụ thể
    postIds: string[]; // danh sách ID bài viết nếu chọn loại 2

    phone: string; // 'NONE' | 'HAVE' | 'HAVE_NOT' (none: không kiểm tra, have: có số điện thoại, have_not: không có số điện thoại)
    email: string; // 'NONE' | 'HAVE' | 'HAVE_NOT' (none: không kiểm tra, have: có email, have_not: không có email)

    rootComment?: number; // 1: comment cấp 1, 2: tất cả

    inbox2inbox: { // kich bản inbox
        active: number;
        block_id: string;
    };

    keyword: KeywordCondition;

    comment: {
        active: number;
        messages: string[];
    };

    inbox: {
        active: number;
        messages: {
            type: string; // 'text' | 'block_id'
            value: string;
            options?: any[]
        }[],
    };

    hide_comment: number; // 1: ẩn, 2: không ẩn

    like_comment: number; // 1: like, 2: không like

    order: number; // thứ tự sắp xếp

    createdTime?: number;

    tags: {
        active: number;
        list: string[];
    };
}

/** Chi tiết bot (/chatbot/index/load) */
export interface LoadBotResponse {
    item: BotItem;
    groups: BotGroup[];
    blocks: BotBlock[];
    cards: BotCard[];
}


/**
 *  Cập nhật Bot (/chatbot/index/updatebot)
 */
export interface UpdateBotDataPayload {
    /** ID của bot cần update */
    botId: string;
    name?: string;
    /** (Optional) Nếu = "connect", hệ thống sẽ xử lý logic kết nối/ngắt kết nối page và đẩy menu lên FB */
    action?: 'connect' | string;
    fanpageId?: string[];
    /** Cho phép ghi đè bot nếu Fanpage đang nối với bot khác */
    isReplaceBot?: boolean;

    settings?: {
        menu?: BotMenuSettings;
        accept_friend_action?: BotSendFriendZaloSettings; // cấu hình chấp nhận bạn bè Zalo cá nhân
    };
}

export interface UpdateBotResponse {
    item?: BotItem;
    error?: string;
    /** Mã lỗi logic (nếu trùng page mà chưa confirm replace) */
    type?: 'page_connected';
}
